import { useUpFetch } from '../utils'

export const useUploadAvatar = (userId: number | undefined) => {
  const upFetch = useUpFetch()

  return {
    uploadAvatar: async (avatar: File) => {
      const formData = new FormData()
      formData.append('avatar', avatar)

      const res = await upFetch<{
        data: {
          id: number
          name: string
          url: string
        }
      }>(`/users/${userId}/avatar`, {
        body: formData,
        method: 'POST',
      })

      return res.data
    },
  }
}
